<template>
  <nav class="navbar-default navbar-static-side" role="navigation">
    <div class="sidebar-collapse">
      <ul class="nav metismenu" id="side-menu">
        <li class="nav-header">
          <div class="dropdown profile-element">
            <span>
              <img alt="Carizy" src="../assets/img/logo-carizy-white.png" class="logo-carizy"/>
            </span>
          </div>
        </li>
        <li v-for="(item, index) in menu" :key="index" class="button-li">
          <a v-if="isSupportPath(item.to)" :href="getPath(item.to)" target="_blank">
            <i class="fa" :class="item.icon"></i>
            <span class="nav-label">{{ item.label }}</span>
            <span v-if="item.children" class="fa arrow"></span>
          </a>
          <a v-else-if="item.to" :href="getPath(item.to)">
            <i class="fa" :class="item.icon"></i>
            <span class="nav-label">{{ item.label }}</span>
            <span v-if="item.children" class="fa arrow"></span>
          </a>
          <a v-else>
            <i class="fa" :class="item.icon"></i>
            <span class="nav-label">{{ item.label }}</span>
            <span v-if="item.children" class="fa arrow"></span>
          </a>
          <ul v-if="item.children" class="nav nav-second-level collapse">
            <li v-for="(child, index) in item.children" :key="index">
              <a v-if="child.to" :href="getPath(child.to)">
                <i class="fa" :class="child.icon"></i>
                {{ child.label }}
              </a>
              <a v-else>
                <i class="fa" :class="child.icon"></i>
                {{ child.label }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
  import store from '../config/store'
  import menu from '../config/menu'
  import userProfileQuery from '../api/query/userProfileQuery.gql'

  export default {
    props: {
      forceMini: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data: () => ({
      userInfos: {
        userProfil: null,
        userIsManager: false,
        managerId: "",
        userIsExpert: false,
        expertId: "",
        expertiseCompany: ""
      },
      urlPath: process.env.VUE_APP_BACKOFFICE_DOMAIN
    }),
    computed: {
      menu () {
        let type = "admin"
        if (this.userInfos && this.userInfos.userProfil) {
          type = this.userInfos.userProfil.type.toLowerCase()
        }
        return menu.filter(function (object) {
          if (Array.isArray(object.role)) {
            return object.role.indexOf(type) !== -1
          } else {
            return (object.role === 'all' || object.role === type)
          }
        })
      },
    },
    methods: {
      getPath(to) {
        if (!to.includes('pro')) {
          // for external url
          if (to === process.env.VUE_APP_SUPPORT) {
            return process.env.VUE_APP_SUPPORT_URL
          }
          return process.env.VUE_APP_BACKOFFICE_CDN_PATH + '/#' + to
        }

        return this.urlPath + to
      },

      isSupportPath(path) {
        return path === process.env.VUE_APP_SUPPORT
      }
    },
    mounted () {
      if (store.data.userInfos) {
        this.userInfos = store.data.userInfos
      } else {
        this.$apollo.query({
          query: userProfileQuery
        }).then(response => {
          store.data.user = response.data
          store.data.user = Object.assign(store.data.user,response.data.userProfil)
          this.saveData()

          let path = '/expertises/create';

          if (store.data.route && store.data.route !== '') {
            let tests = [
              { "regex": '^commandCreate$', "path": '/command/create' },
              { "regex": '^commandList$', "path": '/#/' },
              { "regex": '^disposalList$', "path": '/cession/list' },
              { "regex": '^disposalDetail$', "path": '/cession/' + store.data.disposalId },
              { "regex": '^command[0-9]+$', "path": store.data.route.replace('command', '/command/') }
            ];

            for (let i = 0; i < tests.length; i++) {
              if (RegExp(tests[i].regex).test(store.data.route)) {
                path = tests[i].path;
                break;
              }
            }
          }

          this.$router.push(path)
          history.pushState({}, '', path);
        })
      }
      
      if (this.forceMini) {
        document.querySelector('body').classList.add('mini-navbar')
      } else {
        document.querySelector('body').classList.remove('mini-navbar')
      }
    }

  }
</script>
